import { Notification, LoadingNotification } from './Notification'

interface NotificationItem {
  id: string
  type: 'success' | 'error' | 'warning' | 'info' | 'loading'
  title: string
  message?: string
  duration?: number
}

interface NotificationContainerProps {
  notifications: NotificationItem[]
  onClose: (id: string) => void
}

export function NotificationContainer({ notifications, onClose }: NotificationContainerProps) {
  return (
    <div className="fixed bottom-4 left-4 z-[9999998] space-y-2">
      {notifications.map((notification) => {
        if (notification.type === 'loading') {
          return (
            <LoadingNotification
              key={notification.id}
              id={notification.id}
              title={notification.title}
              message={notification.message}
              onClose={onClose}
            />
          )
        }

        return (
          <Notification
            key={notification.id}
            id={notification.id}
            type={notification.type}
            title={notification.title}
            message={notification.message}
            duration={notification.duration}
            onClose={onClose}
          />
        )
      })}
    </div>
  )
}
